import React, { Component } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import * as appConstants from 'util/appConstants';
import { Input, InputGroup } from 'reactstrap';
import { TextEditor } from '../cmsTextEditor';
import TabSelector from '../../components/TabSelector/tabSelector';

import {
  ContestNameAndDurationContainer,
  ContestNameContainer,
  ContestNameAndDurationWrapContainer,
  Label,
  DateContainer,
  BrandingContainer,
  HorizontalLine,
  LeftAndRightTabContainer,
  LeftTabContainer,
  LeftTabHeading,
  ContestLogoHeading,
  RunTournamentContainer,
  RunTournamentLabelAndCheckbox,
  RunTournamentInputCheckbox,
  RunTournamentLabel,
  EditorLogoContainer,
  UploadAndRemoveButtonContainer,
  ButtonContainer,
  Button,
  InputLogo,
  InputLogoLabel,
  ImageContainer,
  LogoImage,
  CreateAndEditContestContainer,
  BackAndSaveButtonContainer,
  TopButtonContainer,
  ContestHeading,
  RenderTabContainer,
  SponsorTabContainer,
  SponsorTabInnerContainer,
  SponsorDateContainer,
  CompanyNameContainer,
  OldSponsorContainer,
  OldSponsorHeading,
  Select,
  Option,
} from './style';

import { Table, TableBody, TableRow, TableData, TableHead, TableHeading } from '../cmsRankList/style';

let originalSponsorStartDate, originalSponsorEndDate, originalCompanyId;
export class EditAndCreateContest extends Component {
  state = {
    subTab: appConstants.cmsTabs.logo,
    tab: appConstants.cmsTabs.duration,
    contestId: '',
    contestName: '',
    landingPageContentInHTML: '',
    logo: '',
    background: '',
    contestStartDate: '',
    contestEndDate: '',
    candidateDescriptionInHtml: '',
    companyDescriptionInHTML: '',
    autoRun: true,
    tournamentRunTime: '12:00:00',
    landingPageLogo: '',
    sponsorId: '',
    sponsorStartDate: '',
    sponsorEndDate: '',
    sponsorCompany: '',
    companiesList: [],
    oldSponsors: [],
  };

  componentDidMount() {
    if (this.props.contestDetails) {
      this.setState({
        contestId: this.props.contestDetails._id,
        contestName: this.props.contestDetails.name,
        contestStartDate: moment(this.props.contestDetails.startDate).format('YYYY-MM-DD'),
        contestEndDate: moment(this.props.contestDetails.endDate).utc().format('YYYY-MM-DD'),
        landingPageContentInHTML: this.props.contestDetails.landingPageContent,
        logo: this.props.contestDetails.contestLogo,
        landingPageLogo: this.props.contestDetails.landingPageLogo,
        background: this.props.contestDetails.contestBackground,
        candidateDescriptionInHtml: this.props.contestDetails.candidateDescription,
        companyDescriptionInHTML: this.props.contestDetails.companyDescription,
        isTournament: this.props.contestDetails.isTournament,
        isHackathon: this.props.contestDetails.isHackathon,
        shortPath: this.props.contestDetails.shortPath,
        autoRun: this.props.contestDetails.autoRun ? true : false,
        sponsorId: this.props.contestDetails.sponsorId ? this.props.contestDetails.sponsorId : '',
        sponsorStartDate: this.props.contestDetails.sponsorStartDate
          ? moment(this.props.contestDetails.sponsorStartDate).format('YYYY-MM-DD')
          : '',
        sponsorEndDate: this.props.contestDetails.sponsorEndDate
          ? moment(this.props.contestDetails.sponsorEndDate).format('YYYY-MM-DD')
          : '',
        sponsorCompany: this.props.contestDetails.sponsorCompany ? this.props.contestDetails.sponsorCompany : '',
        companiesList: this.props.contestDetails.companiesList,
        oldSponsors: this.props.contestDetails.oldSponsors,
        tournamentRunTime: this.props.contestDetails.tournamentRunTime
          ? this.props.contestDetails.tournamentRunTime
          : '12:00:00',
      });
      originalSponsorStartDate = this.props.contestDetails.sponsorStartDate
        ? moment(this.props.contestDetails.sponsorStartDate).format('YYYY-MM-DD')
        : '';
      originalSponsorEndDate = this.props.contestDetails.sponsorEndDate
        ? moment(this.props.contestDetails.sponsorEndDate).format('YYYY-MM-DD')
        : '';
      originalCompanyId = this.props.contestDetails.sponsorCompany ? this.props.contestDetails.sponsorCompany : '';
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.contestDetails) {
      this.setState({
        contestId: nextProps.contestDetails._id,
        contestName: nextProps.contestDetails.name,
        contestStartDate: moment(nextProps.contestDetails.startDate).format('YYYY-MM-DD'),
        contestEndDate: moment(nextProps.contestDetails.endDate).format('YYYY-MM-DD'),
        landingPageContentInHTML: nextProps.contestDetails.landingPageContent,
        logo: nextProps.contestDetails.contestLogo,
        landingPageLogo: nextProps.contestDetails.landingPageLogo,
        background: nextProps.contestDetails.contestBackground,
        candidateDescriptionInHtml: nextProps.contestDetails.candidateDescription,
        companyDescriptionInHTML: nextProps.contestDetails.companyDescription,
        isHackathon: nextProps.contestDetails.isHackathon,
        shortPath: nextProps.contestDetails.shortPath,
        autoRun: nextProps.contestDetails.autoRun ? true : false,
        sponsorId: nextProps.contestDetails.sponsorId ? nextProps.contestDetails.sponsorId : '',
        sponsorStartDate: nextProps.contestDetails.sponsorStartDate
          ? moment(nextProps.contestDetails.sponsorStartDate).format('YYYY-MM-DD')
          : '',
        sponsorEndDate: nextProps.contestDetails.sponsorEndDate
          ? moment(nextProps.contestDetails.sponsorEndDate).format('YYYY-MM-DD')
          : '',
        sponsorCompany: nextProps.contestDetails.sponsorCompany ? nextProps.contestDetails.sponsorCompany : '',
        oldSponsors: nextProps.contestDetails.oldSponsors ? nextProps.contestDetails.oldSponsors : [],
        tournamentRunTime: nextProps.contestDetails.tournamentRunTime
          ? nextProps.contestDetails.tournamentRunTime
          : '12:00:00',
      });
    }
  }

  saveContest = () => {
    const currentDate = moment().format('YYYY-MM-DD');
    let isActiveSponsor = false;
    if (moment(originalSponsorStartDate).isBefore(currentDate) && moment(originalSponsorEndDate).isAfter(currentDate))
      isActiveSponsor = true;
    if (
      this.state.sponsorId &&
      isActiveSponsor &&
      (originalSponsorStartDate !== this.state.sponsorStartDate || originalCompanyId !== this.state.sponsorCompany)
    ) {
      return toast.error(appConstants.cmsMessages.activeSponsorError);
    }
    if (this.state.sponsorStartDate || this.state.sponsorEndDate || this.state.sponsorCompany) {
      if (
        !isActiveSponsor &&
        (!this.state.sponsorStartDate ||
          !this.state.sponsorEndDate ||
          moment(this.state.sponsorStartDate).isSameOrAfter(this.state.sponsorEndDate) ||
          moment(this.state.sponsorStartDate).isSameOrBefore(currentDate))
      ) {
        return toast.error(appConstants.cmsMessages.sponsorEndDateLessThanStartDate);
      } else if (!this.state.sponsorCompany) {
        return toast.error(appConstants.cmsMessages.sponsorCompanyEmpty);
      }
    }
    if (
      moment(this.state.contestEndDate).isSameOrAfter(this.state.contestStartDate) &&
      moment(this.state.contestEndDate).isSameOrAfter(currentDate)
    ) {
      this.props.saveContest(this.state);
    } else {
      toast.error(appConstants.cmsMessages.endDateLessThanStartDate);
    }
  };

  handleInputs = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  renderNameAndDuration = () => {
    return (
      <ContestNameAndDurationContainer>
        <ContestNameAndDurationWrapContainer>
          <ContestNameContainer>
            <Label>Contest Name:</Label>
            <InputGroup>
              <Input
                type="text"
                name="contestName"
                id="contestName"
                value={this.state.contestName}
                onChange={this.handleInputs}
              />
            </InputGroup>
          </ContestNameContainer>
        </ContestNameAndDurationWrapContainer>
        <ContestNameAndDurationWrapContainer>
          <DateContainer padding="0 10px 0 0">
            <Label>Start date:</Label>
            <InputGroup>
              <Input
                type="date"
                name="date"
                id="contestStartDate"
                value={this.state.contestStartDate}
                onChange={this.handleInputs}
              />
            </InputGroup>
          </DateContainer>
          <DateContainer padding="0 0 0 10px">
            <Label>End date:</Label>
            <InputGroup>
              <Input
                type="date"
                name="date"
                id="contestEndDate"
                min={this.state.contestStartDate}
                value={this.state.contestEndDate}
                onChange={this.handleInputs}
              />
            </InputGroup>
          </DateContainer>
        </ContestNameAndDurationWrapContainer>
        <ContestNameAndDurationWrapContainer>
          <ContestNameContainer>
            <RunTournamentLabelAndCheckbox>
              <RunTournamentInputCheckbox
                type="checkbox"
                checked={this.state.isHackathon}
                onChange={() => {
                  this.setState({ isHackathon: !this.state.isHackathon });
                }}
              />
              <RunTournamentLabel>Contest is hackathon</RunTournamentLabel>
            </RunTournamentLabelAndCheckbox>
          </ContestNameContainer>
          <ContestNameContainer>
            <RunTournamentLabelAndCheckbox>
              <RunTournamentInputCheckbox
                type="checkbox"
                checked={this.state.shortPath}
                onChange={() => {
                  this.setState({ shortPath: this.state.shortPath ? '' : this.state.contestId });
                }}
              />
              <RunTournamentLabel>Contest has short path</RunTournamentLabel>
            </RunTournamentLabelAndCheckbox>
          </ContestNameContainer>
          {this.state.shortPath && (
            <ContestNameContainer disableMargin>
              <Label>Short path used to redirect:</Label>
              <InputGroup>
                <Input
                  type="text"
                  name="shortPath"
                  id="shortPath"
                  value={this.state.shortPath}
                  onChange={this.handleInputs}
                />
              </InputGroup>
              <Label>{`Preview: ${new URL(window.location).host}/c/${this.state.shortPath}`}</Label>
            </ContestNameContainer>
          )}
        </ContestNameAndDurationWrapContainer>
      </ContestNameAndDurationContainer>
    );
  };

  handleImage = (e) => {
    let extension = e.target.value.substr(e.target.value.lastIndexOf('.') + 1);
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      if (e.target.id === 'logo') {
        reader.onload = () => {
          this.setState({ logo: reader.result });
        };
      } else if (e.target.id === 'landingPageLogo') {
        reader.onload = () => {
          this.setState({ landingPageLogo: reader.result });
        };
      } else {
        reader.onload = () => {
          this.setState({ background: reader.result });
        };
      }
    } else {
      e.target.value = '';
      toast.error(appConstants.cmsMessages.chooseImage);
    }
  };

  handleTextEditorChange = (htmlOf, value) => {
    this.setState({ [htmlOf]: value });
  };

  handleTime = (e) => {
    this.setState({ tournamentRunTime: e.target.value });
  };

  renderTabs = () => {
    if (this.state.subTab === appConstants.cmsTabs.logo) {
      return (
        <EditorLogoContainer>
          <UploadAndRemoveButtonContainer>
            <ButtonContainer>
              <InputLogo type="file" name="logo" id="logo" onChange={this.handleImage} />
              <InputLogoLabel>Choose Logo</InputLogoLabel>
            </ButtonContainer>
            {this.state.logo && (
              <ButtonContainer>
                <Button onClick={() => this.setState({ logo: '' })}>Remove</Button>
              </ButtonContainer>
            )}
          </UploadAndRemoveButtonContainer>
          <ImageContainer>{this.state.logo && <LogoImage src={this.state.logo} alt="upload" />}</ImageContainer>
        </EditorLogoContainer>
      );
    } else if (this.state.subTab === appConstants.cmsTabs.landingPageLogo) {
      return (
        <EditorLogoContainer>
          <UploadAndRemoveButtonContainer>
            <ButtonContainer>
              <InputLogo type="file" name="logo" id="landingPageLogo" onChange={this.handleImage} />
              <InputLogoLabel>Choose Logo</InputLogoLabel>
            </ButtonContainer>
            {this.state.landingPageLogo && (
              <ButtonContainer>
                <Button onClick={() => this.setState({ landingPageLogo: '' })}>Remove</Button>
              </ButtonContainer>
            )}
          </UploadAndRemoveButtonContainer>
          <ImageContainer>
            {this.state.landingPageLogo && <LogoImage src={this.state.landingPageLogo} alt="upload" />}
          </ImageContainer>
        </EditorLogoContainer>
      );
    } else {
      return (
        <EditorLogoContainer>
          <ButtonContainer>
            <InputLogo isBackgroundImage type="file" name="background" id="background" onChange={this.handleImage} />
            <InputLogoLabel>Choose Background</InputLogoLabel>
          </ButtonContainer>
          <ImageContainer>
            {this.state.background && <LogoImage isBackgroundImage src={this.state.background} alt="upload" />}
          </ImageContainer>
        </EditorLogoContainer>
      );
    }
  };

  renderBrandingPage = () => {
    return (
      <BrandingContainer>
        <ContestLogoHeading>Contest logo and background</ContestLogoHeading>
        <HorizontalLine />
        <LeftAndRightTabContainer>
          <LeftTabContainer>
            <LeftTabHeading
              isActive={this.state.subTab === appConstants.cmsTabs.logo}
              onClick={() => this.setState({ subTab: appConstants.cmsTabs.logo })}
            >
              Editor Logo
            </LeftTabHeading>
            <LeftTabHeading
              isActive={this.state.subTab === appConstants.cmsTabs.landingPageLogo}
              onClick={() => this.setState({ subTab: appConstants.cmsTabs.landingPageLogo })}
            >
              Landing Page Logo
            </LeftTabHeading>
            <LeftTabHeading
              isActive={this.state.subTab === appConstants.cmsTabs.background}
              onClick={() => this.setState({ subTab: appConstants.cmsTabs.background })}
            >
              Background
            </LeftTabHeading>
          </LeftTabContainer>
          <RenderTabContainer>{this.renderTabs()}</RenderTabContainer>
        </LeftAndRightTabContainer>
      </BrandingContainer>
    );
  };

  renderRunTournament = () => {
    return (
      <RunTournamentContainer>
        <RunTournamentLabelAndCheckbox>
          <RunTournamentInputCheckbox
            type="checkbox"
            checked={this.state.autoRun}
            onChange={() => {
              this.setState({ autoRun: !this.state.autoRun });
            }}
          />
          <RunTournamentLabel>Run Automatically</RunTournamentLabel>
        </RunTournamentLabelAndCheckbox>
        {/* {!this.state.autoRun && (
          <RunTournamentTimeContainer>
            <Label>Set time: </Label>
            <Input
              type="time"
              step="1"
              value={this.state.tournamentRunTime}
              onChange={this.handleTime}
            />
          </RunTournamentTimeContainer>
        )} */}
      </RunTournamentContainer>
    );
  };

  renderSponsor = () => {
    return (
      <SponsorTabContainer>
        <SponsorTabInnerContainer>
          <SponsorDateContainer padding="0 10px 0 0">
            <Label>Start date:</Label>
            <InputGroup>
              <Input
                type="date"
                name="date"
                id="sponsorStartDate"
                value={this.state.sponsorStartDate}
                onChange={this.handleInputs}
              />
            </InputGroup>
          </SponsorDateContainer>
          <SponsorDateContainer padding="0 10px 0 0">
            <Label>End date:</Label>
            <InputGroup>
              <Input
                type="date"
                name="date"
                id="sponsorEndDate"
                value={this.state.sponsorEndDate}
                onChange={this.handleInputs}
              />
            </InputGroup>
          </SponsorDateContainer>
          <CompanyNameContainer padding="0 10px 0 0">
            <Label>Select company:</Label>
            <Select
              value={this.state.sponsorCompany}
              onChange={(e) => {
                this.setState({ sponsorCompany: e.target.value });
              }}
            >
              {!this.state.sponsorCompany && <Option value="">Select company</Option>}
              {this.state.companiesList.map((company, index) => {
                return (
                  <Option value={company._id} key={index}>
                    {company.name}
                  </Option>
                );
              })}
            </Select>
          </CompanyNameContainer>
        </SponsorTabInnerContainer>
        {!!this.state.oldSponsors?.length && (
          <OldSponsorContainer>
            <OldSponsorHeading>Previous Sponsors</OldSponsorHeading>
            <Table>
              <TableHead>
                <TableRow isHeading>
                  <TableHeading>Company</TableHeading>
                  <TableHeading>Sponsor Start Date</TableHeading>
                  <TableHeading>Sponsor End Date</TableHeading>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.oldSponsors.map((sponsor, index) => {
                  return (
                    <TableRow key={index}>
                      <TableData>{sponsor.companyName}</TableData>
                      <TableData>{moment(sponsor.startDate).format('DD-MM-YYYY')}</TableData>
                      <TableData>{moment(sponsor.endDate).format('DD-MM-YYYY')}</TableData>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </OldSponsorContainer>
        )}
      </SponsorTabContainer>
    );
  };

  renderTextEditor = (key) => (
    <TextEditor
      key={key}
      value={this.state[key]}
      handleTextChange={(value) => this.handleTextEditorChange(key, value)}
    />
  );

  render() {
    let tabs = [
      { label: 'Contest Name and Duration', component: this.renderNameAndDuration() },
      { label: 'Landing Page', component: this.renderTextEditor('landingPageContentInHTML') },
      { label: 'Branding', component: this.renderBrandingPage() },
      { label: 'Candidate Description', component: this.renderTextEditor('candidateDescriptionInHtml') },
      { label: 'Company Description', component: this.renderTextEditor('companyDescriptionInHTML') },
    ];

    if (this.props.userRole && this.props.userRole === appConstants.userRoles.SUPER_ADMIN) {
      tabs.push({ label: 'Sponsor', component: this.renderSponsor() });
    }
    if (this.state.isTournament) {
      tabs.push({ label: 'Run Cron', component: this.renderRunTournament() });
    }

    return (
      <CreateAndEditContestContainer>
        <BackAndSaveButtonContainer>
          <TopButtonContainer floatLeft>
            {this.props.history && (
              <Button onClick={() => this.props.history.goBack()}>
                <i className="fa fa-arrow-left">&nbsp;</i>Back
              </Button>
            )}
            <ContestHeading>{`${this.state.contestName} Contest`}</ContestHeading>
          </TopButtonContainer>
          <TopButtonContainer>
            <Button floatRight onClick={() => this.saveContest()}>
              Save Contest
            </Button>
          </TopButtonContainer>
        </BackAndSaveButtonContainer>
        <TabSelector items={tabs}></TabSelector>
      </CreateAndEditContestContainer>
    );
  }
}
